<template>
  <header :class="{ 'fade-in': showWhiteHeader, 'fade-out': !showWhiteHeader }">
    <div class="branding" v-if="showWhiteHeader" aria-hidden="true">
      <img src="../assets/img/logo/circle.png" alt="" :class="{ 'slide-x': !stowAway, 'hide-x': stowAway }">
      <router-link :to="{ name: 'home' }" class="name" aria-label="debye.io">
        <div aria-hidden="true" v-for="(c, i) in brandName" :key="i"
             :class="{ 'show': !stowAway, 'hide': stowAway }">{{ c }}</div>
      </router-link>
    </div>
    <Navigation />
  </header>
</template>

<script>
import Navigation from '../components/Navigation'
import { mapState } from 'vuex'

export default {
  name: 'Header',
  components: {
    Navigation
  },
  computed: {
    ...mapState([
      'showWhiteHeader'
    ])
  },
  data() {
    return {
      stowAway: true,         // updated based on showWhiteHeader state
      brandName: [...'debye.io']
    };
  },
  watch: {
    showWhiteHeader() {
      // animation will happen when white banner was not displayed in previous route/state
      if (this.showWhiteHeader) {
        this.slide();
      }
    }
  },
  methods: {
    slide() {
      setTimeout(() => {
        this.stowAway = false;
      }, 1000);
      this.stowAway = true;
    }
  },
  mounted() {
    // redo animation if page is refreshed
    if (this.showWhiteHeader) {
      this.slide();
    }
  }
};
</script>

<style scoped lang="scss">
@import '../assets/css/variables';

header {
  background-color: rgba(255, 255, 255, 0.97);
  border-bottom: 1px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2);
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: z('nav-bar');
}

$init-x: 85;
$init-delay: 1.5;
$init-duration: .5s;
.branding {
  margin: 0.5rem 0 0 1rem;
  img {
    border: 1px solid $theme;
    border-radius: 20px;
    box-shadow: 2px 1px 3px darkgrey;
    height: 40px;
    width: 40px;
    &.hide-x {
      transform: translateX(-70px);
    }
    &.slide-x {
      transition: all 1s;
      transform: translateX(0);
    }
  }
  .name {
    border: 0;
    display: inline-block;
    height: 40px;
    padding: 0.45rem 1rem;
    vertical-align: top;
    &:hover {
      opacity: 0.8;
    }
    div {
      display: inline-block;
      color: $theme;
      @extend %font-regular-semi-bold;
      font-weight: 600;
      .show {
        transform: translateX(0);
      }
      // TODO: use sass to compute the loop
      &:first-child {
        &.hide {
          transform: translateX(-#{$init-x}px);
        }
        &.show {
          transition: all $init-duration ease-in #{$init-delay}s;
        }
      }
      &:nth-child(2) {
        &.hide {
          transform: translateX(-#{$init-x + 10}px);
        }
        &.show {
          transition: all $init-duration ease-in #{$init-delay + .25}s;
        }
      }
      &:nth-child(3) {
        &.hide {
          transform: translateX(-#{$init-x + 20}px);
        }
        &.show {
          transition: all $init-duration ease-in #{$init-delay + .5}s;
        }
      }
      &:nth-child(4) {
        &.hide {
          transform: translateX(-#{$init-x + 30}px);
        }
        &.show {
          transition: all $init-duration ease-in #{$init-delay + .75}s;
        }
      }
      &:nth-child(5) {
        &.hide {
          transform: translateX(-#{$init-x + 40}px);
        }
        &.show {
          transition: all $init-duration ease-in #{$init-delay + 1}s;
        }
      }
      &:nth-child(6) {
        &.hide {
          transform: translateX(-#{$init-x + 50}px);
        }
        &.show {
          transition: all $init-duration ease-in #{$init-delay + 1.25}s;
        }
      }
      &:nth-child(7) {
        &.hide {
          transform: translateX(-#{$init-x + 60}px);
        }
        &.show {
          transition: all $init-duration ease-in #{$init-delay + 1.5}s;
        }
      }
      &:last-child {
        &.hide {
          transform: translateX(-#{$init-x + 70}px);
        }
        &.show {
          transition: all $init-duration ease-in #{$init-delay + 1.75}s;
        }
      }
    }
  }
}
</style>
